'use client'
import { FaSearch } from 'react-icons/fa'
import { useState, useEffect } from 'react'
import { updateSearchParams, getSearchParams, removeSearchParam, priceFormatter } from "@utils";
import { useRouter } from 'next/navigation'

const NameFilter = ({ title, dictionary, lang }) => {
    const router = useRouter();

    const [name, setName] = useState('')

    const handleUpdateParams = (e) => {
        const nameValue = e || '';
        setName(nameValue);

        let newPathName;
        if (nameValue === '') {
            newPathName = removeSearchParam(title);
        } else {
            newPathName = updateSearchParams(title, nameValue);
        }

        router.push(newPathName);
        router.refresh();
    };

    
    useEffect(() => {
        const newValue = getSearchParams('name')

        if (newValue != undefined) {
            setName(newValue)
        } else {
            if (newValue === null) {
                setName(newValue)
            } else {
                setName(newValue)
            }
        }

    }, [setName])

    return (
        <div className='w-full mt-1'>
            <span className='text-sm text-secondary'>{dictionary.filter.nameOrProject}:</span>
            <div className='flex flex-row'>
                {/* <div className='z-1 relative w-full cursor-default overflow-hidden rounded-l-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'> */}
                <input
                    className='w-full  py-2 mt-1 rounded-sm border-[1px] border-forth text-secondary pl-2 text-sm leading-5 focus:ring-0'
                    placeholder={dictionary.filter.enterName}
                    type='text'
                    name='id'
                    value={name}
                    onChange={(e) => handleUpdateParams(e.target.value)}
                // required
                />
            </div>
        </div>
    )
}

export default NameFilter